import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Owners from './pages/Owners.jsx';
import Dogs from './pages/Dogs.jsx';
import Daycare from './pages/DaycareManagement.jsx';
import Hotel from './pages/Hotel.jsx';
import { AuthProvider } from './context/AuthContext.jsx';
import PrivateRoute from './components/PrivateRoute.jsx';
import DaycarePackages from './pages/DaycarePackages.jsx';
import ActivePackages from './pages/ActivePackages.jsx';
import PackageHistory from './pages/PackageHistory.jsx';
import DaycareCheckin from './pages/DaycareCheckin.jsx';
import DailyAssistance from './pages/DailyAssistance.jsx';
import DaycareCheckout from './pages/DaycareCheckout.jsx';
import DaycareManagement from './pages/DaycareManagement.jsx';
import UserManagement from './pages/UserManagement.jsx';
import Settings from './pages/Settings.jsx';
import Vet from './pages/Vet.jsx';
import Grooming from './pages/Grooming.jsx';
import Contacts from './pages/Contacts.jsx';
import More from './pages/More.jsx';
import Sales from './pages/Sales.jsx';
import SaleBuilder from './pages/SaleBuilder.jsx';
import SaleDetail from './pages/SaleDetail.jsx';
import SaleReceipt from './pages/SaleReceipt.jsx';
import CatalogManager from './pages/CatalogManager.jsx';
import Reports from './pages/Reports.jsx';
import HotelIntakeFormPage from './pages/HotelIntakeFormPage.jsx';
import HotelIntakeSummaryPage from './pages/HotelIntakeSummaryPage.jsx';
import HappyBus from './pages/HappyBus.jsx';
import PersonalDirectory from './pages/PersonalDirectory.jsx';
import PersonalExpediente from './pages/PersonalExpediente.jsx';
import PersonalEdit from './pages/PersonalEdit.jsx';
import NuevoEmpleado from './pages/NuevoEmpleado.jsx';
import OwnerProfile from './pages/OwnerProfile.jsx';

function App() {
    return (
        <Router>
            <AuthProvider>
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                    <Route path="/owners" element={<PrivateRoute><Owners /></PrivateRoute>} />
                    <Route path="/owners/:id" element={<PrivateRoute><OwnerProfile /></PrivateRoute>} />
                    <Route path="/dogs" element={<PrivateRoute><Dogs /></PrivateRoute>} />
                    <Route path="/daycare" element={<PrivateRoute><Daycare /></PrivateRoute>} />
                    <Route path="/hotel" element={<PrivateRoute><Hotel /></PrivateRoute>} />
                    <Route path="/daycare/packages" element={<PrivateRoute><DaycarePackages /></PrivateRoute>} />
                    <Route path="/daycare/packages/active" element={<ActivePackages />} />
                    <Route path="/daycare/packages/history" element={<PrivateRoute><PackageHistory /></PrivateRoute>} />
                    <Route path="/daycare/checkin" element={<DaycareCheckin />} />
                    <Route path="/daycare/checkin/logs" element={<DailyAssistance />} />
                    <Route path="/daycare/checkout" element={<DaycareCheckout />} />
                    <Route path="/user-management" element={
                        <PrivateRoute>
                            <UserManagement />
                        </PrivateRoute>
                    } />
                    <Route path="/vet" element={<PrivateRoute><Vet /></PrivateRoute>} />
                    <Route path="/grooming" element={<PrivateRoute><Grooming /></PrivateRoute>} />
                    <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
                    <Route path="/settings/catalog" element={<PrivateRoute><CatalogManager /></PrivateRoute>} />
                    <Route path="/settings/reports" element={<PrivateRoute><Reports /></PrivateRoute>} />
                    <Route path="/settings/personal" element={<PrivateRoute><PersonalDirectory /></PrivateRoute>} />
                    <Route path="/settings/personal/new" element={<PrivateRoute><NuevoEmpleado /></PrivateRoute>} />
                    <Route path="/settings/personal/:id" element={<PrivateRoute><PersonalExpediente /></PrivateRoute>} />
                    <Route path="/settings/personal/:id/edit" element={<PrivateRoute><PersonalEdit /></PrivateRoute>} />
                    <Route path="/users" element={<PrivateRoute><UserManagement /></PrivateRoute>} />
                    <Route path="/contacts" element={<PrivateRoute><Contacts /></PrivateRoute>} />
                    <Route path="/more" element={<PrivateRoute><More /></PrivateRoute>} />
                    <Route path="/pos" element={<PrivateRoute><Sales /></PrivateRoute>} />
                    <Route path="/pos/new" element={<PrivateRoute><SaleBuilder /></PrivateRoute>} />
                    <Route path="/pos/:id" element={<PrivateRoute><SaleDetail /></PrivateRoute>} />
                    <Route path="/pos/:id/edit" element={<PrivateRoute><SaleBuilder /></PrivateRoute>} />
                    <Route path="/pos/:id/receipt" element={<PrivateRoute><SaleReceipt /></PrivateRoute>} />
                    <Route path="/happy-bus" element={<PrivateRoute><HappyBus /></PrivateRoute>} />
                    {/* Public — no auth, for owner self-service */}
                    <Route path="/hotel/intake/:bookingId" element={<HotelIntakeFormPage />} />
                    {/* Staff shortcut — still public route, staffMode flag adds nav back */}
                    <Route path="/hotel/intake/:bookingId/staff" element={<HotelIntakeFormPage staffMode={true} />} />
                    {/* Read-only summary — shareable with team */}
                    <Route path="/hotel/intake/:bookingId/summary" element={<HotelIntakeSummaryPage />} />
                </Routes>
            </AuthProvider>
        </Router>
    );
}

export default App;

